import { ApolloLink } from "@apollo/client";
const cloudflareAccessLink = new ApolloLink((operation, forward)=>{
    if ('production' !== process.env.APP_ENV && process.env.CLOUDFLARE_ACCESS_CLIENT_ID && process.env.CLOUDFLARE_ACCESS_CLIENT_SECRET) operation.setContext(({ headers = {} })=>({
            headers: {
                ...headers,
                'CF-Access-Client-Id': process.env.CLOUDFLARE_ACCESS_CLIENT_ID,
                'CF-Access-Client-Secret': process.env.CLOUDFLARE_ACCESS_CLIENT_SECRET
            }
        }));
    return forward(operation);
});
const links_cloudflareAccessLink = cloudflareAccessLink;
export default links_cloudflareAccessLink;
export { cloudflareAccessLink };
